import axios from 'axios'
import md5 from 'js-md5'
import openLogin from '@/utils/login';
import { getStorage } from './index'

const instance = axios.create()

instance.interceptors.request.use(config => {
  config.method = (config.method || 'GET').toUpperCase().trim()
  if (config.method === 'POST') {
    config.data = addSign(config.data)
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      config.data = qs(config.data)
    }
  } else {
    config.params = addSign(config.params)
  }
  return config
})
instance.interceptors.response.use((res) => {
  res = res || {}
  let data = res.data
  if (!data) {
    try {
      data = JSON.parse(res.request.responseText);
    } catch (e) {}
    if(!data) {
      data = {}
    }
  }
  const config = res.config || {}

  if (config.keepResponse) {
    return res
  }
  // 2: 异地登录, 3: 超时
  if (+data.code === 2 || +data.code === 3) {
    localStorage.removeItem('loginWay')
    localStorage.removeItem('user_id')
    localStorage.removeItem('login_token')
    localStorage.removeItem('name')
    localStorage.removeItem('phone')
    openLogin()
    return Promise.reject({ msg: data.message || data.msg || (+data.code === 2 ? '异地登录' : +data.code === 3 ? '登录超时' : '接口出错') })
  }

  if (`${data.code}`.trim() === '0') {
    if(/\/Login\/opt$/.test(config.url.split('?')[0]) || /\/Login$/.test(config.url.split('?')[0])) {
      return {
        ...data.data,
        login_token: data.login_token
      }
    }
    return data.data
  }
  return Promise.reject({ msg: data.message || data.msg || '接口出错' })
})

export default function ajax(url, config, ...args) {
  let flag = true
  if(/Microsoft\s*Internet\s*Explorer/i.test(navigator.appName)) {
    flag = false
    const ieMatch = /msie\s+(\d+)/i.exec(navigator.userAgent)
    if(ieMatch && ieMatch[1] > 9) {
      flag = true
    }
  }
  if(flag) {
    return instance(url, config, ...args)
  }
  config = config || {}
  config.headers = config.headers || {};
  config.method = (config.method || 'GET').toUpperCase().trim();

  return new Promise((resolve, reject) => {
    const xdr = new (window.XDomainRequest)();
    let qsData = qs(addSign({
      ...config.data,
      ...config.params
    }))

    url = `${url}${qsData ? url.indexOf('?') > -1 ? '&' : '?' : ''}${qsData}`
    qsData = url.split('?')[1] || ''
    xdr.open(config.method, url);

    xdr.onload = () => {
      let res = {}
      try {
        res = JSON.parse(xdr.responseText)
      } catch (err) {}
      if(config.keepResponse) {
        return resolve(res)
      }

      // 2: 异地登录, 3: 超时
      if (+res.code === 2 || +res.code === 3) {
        localStorage.removeItem('loginWay')
        localStorage.removeItem('user_id')
        localStorage.removeItem('login_token')
        localStorage.removeItem('name')
        localStorage.removeItem('phone')
        openLogin()
        return reject({ msg: res.message || res.msg || (+res.code === 2 ? '异地登录' : +res.code === 3 ? '登录超时' : '接口出错') })
      }

      if (`${res.code}`.trim() === '0') {
        if(/\/Login\/opt$/.test(url.split('?')[0]) || /\/Login$/.test(url.split('?')[0])) {
          return resolve({
            ...res.data,
            login_token: res.login_token
          })
        }
        return resolve(res.data)
      }
      reject({ msg: res.message || res.msg || '接口出错' })
    };
    xdr.onerror = () => reject({ msg: '接口出错' });
    setTimeout(() => {
      if(qsData && config.method === 'POST') {
        xdr.send(qsData);
      } else {
        xdr.send();
      }
    }, 0)
  })
}

export function addSign(param = {}) {
  let { user_id, login_token, device_id, device_type } = param
  user_id = user_id || getStorage('user_id') || ''
  login_token = login_token || getStorage('login_token') || ''
  device_id = device_id || genDeviceId()
  device_type = device_type || 'pc'
  const rand = Math.floor(Math.random() * (10000 - 1000)) + 1000
  const timestamp = new Date().getTime()
  const token = md5(`${rand}${timestamp}${user_id}${device_id}${device_type}`)

  return {
    ...param,
    rand,
    timestamp,
    user_id,
    device_id,
    device_type,
    login_token,
    token
  }
}

function genDeviceId() {
  if (!localStorage.paSlotMachineDeviceId) {
    const arr = Array.from({ length: 6 }).map(() => Math.floor(Math.random() * 100000))
    localStorage.paSlotMachineDeviceId = md5(`${new Date().getTime()}-${arr.join('-')}`)
  }
  return localStorage.paSlotMachineDeviceId
}

function qs(q = {}) {
  const stringify = (k, v, needBracket) => {
    if (needBracket) {
      k = `[${k}]`
    }
    let arr = []
    if (v && typeof v === 'object') {
      Object.keys(v).forEach(k => arr.push(...stringify(k, v[k], true)))
      arr = arr.map(item => `${k}${item}`)
    } else {
      arr.push(`${k}=${v}`)
    }
    return needBracket ? arr : arr.join('&')
  }
  return Object.keys(q).map(k => stringify(k, q[k])).join('&')
}
